import { User } from '@model/user/user';
import { Component } from '@angular/core';
import { UserService } from '@service/user/user.service';
import { NavigationItem } from '@model/navigation-item/navigation-item';
import { MenuStructureService } from '@service/menu-structure/menu-structure.service';
import { ScrollService } from '@service/scroll.service';

@Component({
  selector: 'app-profile-nav',
  templateUrl: './profile-nav.component.html',
  styleUrls: ['./profile-nav.component.scss'],
})
export class ProfileNavComponent {
  public navpoints: NavigationItem[];

  public user: User;

  public loading: boolean = false;

  constructor(
    private userService: UserService,
    private menuStructureService: MenuStructureService,
    private scrollService: ScrollService,
  ) {
    this.navpoints = this.menuStructureService.getProfileMenuStructure(userService);
    this.userService.userObservable.subscribe((user) => {
      if (user) {
        this.user = user;
      }
    });
  }

  public click(item: NavigationItem): void {
    this.scrollService.scrollToTop();

    // if it is a custom action -> execute it
    if (typeof item.action != 'undefined') {
      item.action();
      return;
    }

    if (item.target.toLowerCase().startsWith('http')) window.open(item.target, '_blank');
  }
}
